export const calculateDiscountPrice = (amount, discount, type) => {
  const result = {
    beforeDiscountAmount: 0,
    discountAmount: 0,
    discountPercentage: 0,
    afterDiscountAmount: 0,
    error: "",
  };

  const parsedAmount = parseFloat(amount);
  if (isNaN(parsedAmount) || parsedAmount <= 0) {
    result.error = "Invalid amount";
    return result;
  }

  const parsedDiscount = parseFloat(discount);
  if (isNaN(parsedDiscount) || parsedDiscount < 0) {
    result.error = "Invalid discount";
    return result;
  }

  result.beforeDiscountAmount = parseFloat(parsedAmount.toFixed(2));

  if (type === "percentage") {
    if (parsedDiscount > 100) {
      result.error = "Percentage discount cannot be more than 100%";
      return result;
    }

    const discountValue = (parsedAmount * parsedDiscount) / 100;
    result.discountAmount = parseFloat(discountValue.toFixed(2));
    result.discountPercentage = parsedDiscount;
  }

  if (type === "amount") {
    if (parsedDiscount > parsedAmount) {
      result.error = "Fixed discount cannot exceed total amount";
      return result;
    }

    result.discountAmount = parseFloat(parsedDiscount.toFixed(2));
    result.discountPercentage = parseFloat(
      ((parsedDiscount / parsedAmount) * 100).toFixed(2)
    );
  }

  result.afterDiscountAmount = parseFloat(
    (parsedAmount - result.discountAmount).toFixed(2)
  );

  return result;
};

export const calculateDiscount = (amount, type, value) => {
  const parsedAmount = parseFloat(amount);
  const parsedValue = parseFloat(value);

  if (isNaN(parsedAmount) || parsedAmount <= 0) {
    return { error: "Invalid amount" };
  }

  if (type === "percentage") {
    if (isNaN(parsedValue) || parsedValue < 0 || parsedValue > 100) {
      return { error: "Invalid percentage" };
    }
    const discountAmount = (parsedAmount * parsedValue) / 100;
    return {
      discountAmount: parseFloat(discountAmount.toFixed(2)),
      discountPercentage: parsedValue,
      afterDiscountAmount: parseFloat(
        (parsedAmount - discountAmount).toFixed(2)
      ),
    };
  } else if (type === "amount") {
    if (isNaN(parsedValue) || parsedValue < 0 || parsedValue > parsedAmount) {
      return { error: "Invalid fixed discount" };
    }
    const discountPercentage = (parsedValue / parsedAmount) * 100;
    return {
      discountAmount: parseFloat(parsedValue.toFixed(2)),
      discountPercentage: parseFloat(discountPercentage.toFixed(2)),
      afterDiscountAmount: parseFloat((parsedAmount - parsedValue).toFixed(2)),
    };
  }

  return { error: "Invalid discount type" };
};

export const calculatePreferredLoginPrice = (
  amount,
  preferredDiscountArray
) => {
  const parsedAmount = parseFloat(amount);

  const defaultResult = {
    beforeDiscountAmount: parsedAmount || 0,
    discountAmount: 0,
    discountPercentage: 0,
    afterDiscountAmount: parsedAmount || 0,
    offerName: "",
    error: "",
  };

  if (isNaN(parsedAmount) || parsedAmount <= 0) {
    return { ...defaultResult, error: "Invalid amount" };
  }

  if (
    !Array.isArray(preferredDiscountArray) ||
    preferredDiscountArray.length === 0
  ) {
    return defaultResult;
  }

  const discountData = preferredDiscountArray[0]; // only apply first discount if multiple
  const {
    discount_type,
    discount_percentage,
    discount_amount,
    offer_name,
  } = discountData;

  const discountValue =
    discount_type === "percentage" ? discount_percentage : discount_amount;
  const discountResult = calculateDiscount(
    parsedAmount,
    discount_type,
    discountValue
  );

  if (discountResult.error) {
    return { ...defaultResult, error: discountResult.error };
  }

  return {
    beforeDiscountAmount: parseFloat(parsedAmount.toFixed(2)),
    discountAmount: parseFloat(discountResult.discountAmount.toFixed(2)),
    discountPercentage: parseFloat(discountResult.discountPercentage),
    afterDiscountAmount: parseFloat(discountResult.afterDiscountAmount.toFixed(2)),
    offerName: offer_name || "",
    error: "",
  };
};
